import { SectionLabel } from "./WhatMakesSpecial";

const sports = [
  {
    icon: "ri-football-line",
    title: "Football",
    items: [
      { name: "A-League & Socceroos", desc: "Full coverage of Australian domestic football plus international matches — match winner, Asian handicap, over/under and more." },
      { name: "Premier League & Champions League", desc: "All major European competitions with deep markets including correct score, first goalscorer and both teams to score." },
    ],
  },
  {
    icon: "ri-basketball-line",
    title: "Basketball (NBL & NBA)",
    items: [
      { name: "NBL — National Basketball League", desc: "Australia&apos;s premier basketball competition with full match betting, point spreads and player performance markets." },
      { name: "NBA", desc: "All 30 teams covered with moneylines, totals, spreads and live in-play betting throughout the season." },
    ],
  },
  {
    icon: "ri-gamepad-line",
    title: "eSports",
    items: [
      { name: "League of Legends & CS2", desc: "Map winner, match winner, tournament outright and kill total markets on all major international eSports events." },
      { name: "Dota 2 & Valorant", desc: "Full coverage of The International, VCT and other premier eSports tournaments with live in-play betting." },
    ],
  },

];

export default function SportsSection() {
  return (
    <section id="sports" className="max-w-5xl mx-auto px-6 py-12">
      <SectionLabel>Sports Betting</SectionLabel>
      <p className="text-white/40 text-sm leading-relaxed mb-10 max-w-2xl">
        Rolex9 covers all major sports with a focus on Australian favourites — A-League, NBL, horse racing and the Australian Open. Competitive odds, deep markets and live in-play betting across every sport.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {sports.map((sport, i) => (
          <div
            key={i}
            className="glass-card rounded-2xl p-6 hover:border-[#c9a84c]/15 transition-all duration-300 group"
            style={{ borderColor: "rgba(255,255,255,0.05)" }}
          >
            <div className="flex items-center gap-3 mb-5">
              <div
                className="w-9 h-9 flex items-center justify-center rounded-xl"
                style={{ background: "linear-gradient(135deg, rgba(201,168,76,0.15), rgba(107,33,168,0.15))" }}
              >
                <i className={`${sport.icon} text-[#c9a84c] text-base`}></i>
              </div>
              <h3 className="text-white/70 font-semibold text-sm" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                {sport.title}
              </h3>
            </div>
            <div className="space-y-3">
              {sport.items.map((item, j) => (
                <div key={j} className="border-l border-[#c9a84c]/15 pl-3">
                  <p className="text-[#c9a84c]/60 text-xs font-medium mb-0.5">{item.name}</p>
                  <p className="text-white/25 text-xs leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
